/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class TemplatesRoute extends Route {
  // Services
  @service
  store;

  model() {
    return hash({
      templates: this.store.findAll('enrolments/schema'),
      schools: this.store.findAll('school'),
    });
  }
}
